import { render } from "./CompanyInformationSection.vue?vue&type=template&id=23150ad6"
import script from "./CompanyInformationSection.vue?vue&type=script&lang=js"
export * from "./CompanyInformationSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__